import { render } from "./video-player.vue?vue&type=template&id=5a6b6943&scoped=true"
import script from "./video-player.vue?vue&type=script&lang=js"
export * from "./video-player.vue?vue&type=script&lang=js"

import "./video-player.vue?vue&type=style&index=0&id=5a6b6943&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6b6943"]])

export default __exports__